import { Pipe, PipeTransform } from '@angular/core';
import { CommonFunctionsService } from '../../../providers/Global/commonFunctions.service';

@Pipe({
  name: 'getNextMonday'
})
export class GetNextMondayPipe implements PipeTransform {

  constructor(private commonFunctionsService: CommonFunctionsService) { }

  transform(value: number): string {
    // return this.commonFunctionsService.getNextDayOfTheWeek('mon', true);
    return '';
  }

}
